<template>
    <base-modal
        :reference="'addActivityDurationType'"
        :title="'Añadir duración de actividad'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir una nueva duración de actividad
                </p>
            </div>
            <form>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Nombre de la duración <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            placeholder="Inserte nombre"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Código de la duración <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.code"
                            placeholder="Inserte cóidog"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Precio tarifa del guía <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.guide_rate"
                            placeholder="Inserte cóidog"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        Los campos nombre, código, precio tarifa son obligatorios
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
    components: {
        BaseModal,
    },
    data() {
        return {
            show: false,
            form: {
                name: '',
                code: '',
                guide_rate: 0
            }
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addActivityDurationType";
            if (modalId == current) {
                this.show = true
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            
            let data = {
                payload: {...this.form}
            }
            await this.$store.dispatch("activityDurationTypes/createActivityDurationType", data )
            .then( () => {
                // reset form data
                this.form = {
                    name: '',
                    code: '',
                    guide_rate: 0
                }

                this.$bvModal.hide("addActivityDurationType");
                this.$notify({
                    group: "foo",
                    title: "Duración añadida",
                    text: "Se ha creado una duración de actividad",
                    type: "success",
                });
            })
            .catch()
            
        }
    },
    computed: {
        errors() {
            if ( this.form.name == '' || this.form.code == '' ) {
                return true
            }
            return false
        }
    }
}
</script>